export type ReleaseVersion = 'r1' | 'r2';

export interface ConversationVisualizerBotConfig {
  env: string;
  apiUrl: string;
  apiKey: string;
}

export const conversationVisualizerEnvironments: {
  [env: string]: {
    [botId: string]: ConversationVisualizerBotConfig;
  };
} = {
  dev: {
    'b2c-support-r2': {
      env: 'dev',
      apiUrl: 'https://b2c.dev.bot-autoatencion.git.copec.cl/v1/conversation-data',
      apiKey: 'gAUEebIG0o1PuQVZog9i556DDiwz0rxX90GN11Hw'
    },
    'b2c-support-r1': {
      env: 'dev',
      apiUrl: 'https://b2c.dev.bot-autoatencion.git.copec.cl/r1/conversation-data',
      apiKey: '0m2zqAGefJ6lfgyxHGuzK2jWeOG6yKpr1JFNxYcn'
    }
  },
  stg: {
    'b2c-support-r2': {
      env: 'stg',
      apiUrl: 'https://b2c.stg.bot-autoatencion.git.copec.cl/v1/conversation-data',
      apiKey: 'kFrCtYgEOg3bR5tOegQo51NHfXaAJRkh9MbVcNyQ'
    },
    'b2c-support-r1': {
      env: 'stg',
      apiUrl: 'https://b2c.stg.bot-autoatencion.git.copec.cl/r1/conversation-data',
      apiKey: 'ns6vpv0hx233Nzs4pCj875EOjiRTAIRO2wDBMtpc'
    }
  },
  prd: {
    'b2c-support-r2': {
      env: 'prd',
      apiUrl: 'https://b2c.prd.bot-autoatencion.git.copec.cl/v1/conversation-data',
      apiKey: 'bpXqRRkaI017Gu0LgKELK1UHxTuhpIW3hY741Kud'
    },
    'b2c-support-r1': {
      env: 'prd',
      apiUrl: 'https://b2c.prd.bot-autoatencion.git.copec.cl/r1/conversation-data',
      apiKey: 'izXLkKldLs75DGvVhFEaA19HxQa3DdUT5fTsDEZf'
    }
  }
}